import { logGreyErrorFromAccounts } from 'owa-account-analytics';

import setSharedSourcesMutator from '../actions/setSharedSources';
import onSharedSourcesChanged from '../actions/onSharedSourcesChanged';
import getAccountBySourceId from '../selectors/getAccountBySourceId';
import type { AdditionalAccountInfo } from '../store/schema/AccountSourceList';

/**
 * Sets the shared sources and then notifies of changes to the shared sources
 * @param coprincipalSourceId SourceId of the account for which shared sources are to be set
 * @param sharedAccountInfo Information to be set
 */
export default function setSharedSources(
    coprincipalSourceId: string,
    sharedAccountInfo: AdditionalAccountInfo
): void {
    const account = getAccountBySourceId(coprincipalSourceId);
    if (!account) {
        // This should only happen if the account is removed while the network call(s) to get information
        // about shared mailboxes (auto-mapped or manually added) is happening.
        const e = new Error('AcctSetSharedSources-AccountNotFound');
        logGreyErrorFromAccounts('AcctSetSharedSources-AccountNotFound', e);

        return;
    }

    setSharedSourcesMutator(coprincipalSourceId, sharedAccountInfo);
    onSharedSourcesChanged(account);
}
